import React, { useState } from "react";
import styles from '../styles/awardList.module.scss'
import { useTranslation } from "react-i18next";

const AwardList = ({ lists }) => {
  const { t } = useTranslation('record')
  const items = [t('orderNumber'), t('eventName'), t('prizeName'), t('status'), t('date')]

  return (
    <div className={styles.awardList}>
      <div className={styles.title}>
        {items.map((v, index)=>{
          return <div key={index} className={styles.item}>{v}</div>
        })}
      </div>

      <div className={styles.content}>
        {lists.map((v,index)=>{
          
          let statusText = t('pendingReview');
          if (v.status == 0) {
          } else if (v.status == 1) {
              statusText = t('approved');
          } else if (v.status == 2) {
              statusText = t('rejected');
          }

          return <div key={index} className={styles.list}>
            <div>{v.orderNo}</div>
            <div>{v.activityName}</div>
            <div>{v.giftName}</div>
            <div className={styles.statusText}>{statusText}</div>
            <div>{v.createdAt}</div>
          </div>
        })}
      </div>  
    </div>
  )
}

export default AwardList